import styled from 'styled-components'

export const TextPreferencesToggleWrapper = styled.div`
  margin-top: ${o => o.theme.spacing(6)};
`
